module.exports = "data:image/gif;base64,R0lGODlhEAABAIAAAP///wAAACH5BAEAAAAALAAAAAAQAAEAAAIEhI8JBQA7"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/doc_icons/space.gif
// module id = b3Bj
// module chunks = 1